// components/ui/KPICard.tsx
type KPICardProps = {
  title: string;
  value: number | string | null | undefined;
  loading?: boolean;
  hint?: string;
};

const KPICard = ({ title, value, loading, hint }: KPICardProps) => {
  // if value is a number and it's larger than 5 digits, add commas e.g. 100000000 -> 100,000,000
  const formattedValue = typeof value === "number" ? value.toLocaleString() : value;
  return (
    <div className="flex-grow rounded-lg bg-white shadow-sm border border-gray-200 p-2 min-w-[130px]">      
      <div className="text-black/80 text-xl font-semibold tabular-nums">
        {loading ? <span className="inline-block h-6 w-20 animate-pulse rounded bg-gray-200" /> : formattedValue ?? "—"}
      </div>
      {hint && <div className="text-[11px] text-black mt-1">{hint}</div>}
      <div className="text-[11px] text-black/80">{title}</div>
    </div>
  );
};
export default KPICard;
